import './styles/quasar.scss';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/line-awesome/line-awesome.css';

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {},
  extras: [
    'material-icons',
    'mdi-v5',
    'ionicons-v4',
    'eva-icons',
    'fontawesome-v5',
    'themify',
    'line-awesome',
    'bootstrap-icons',
  ],
};
